module.exports = __webpack_public_path__ + "static/img/jianting2.df822c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/jianting2.png
// module id = 40M5
// module chunks = 24